/* eslint-disable import/no-unresolved,import/no-duplicates,react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { MAIN_ICON_COLORS } from 'assets/components';
import { SecurityTOTPBodyLayout } from 'assets/components';
import { isIOS } from 'react-device-detect';
import { copyToClipboard } from '../../../utilities/helpers';
import { ICONS } from '../../../components/Icon/constants';
import Icon from '../../../components/Icon';
import Input from '../../../components/Input';

const SecuritySaveTOTPKey = () => {
  const { t: translate } = useTranslation();

  const history = useHistory();
  const { state } = useLocation();

  useEffect(() => {
    if ((!state?.email && !state?.username) || !state?.secret) {
      history.push('/onboarding/login');
    }
  }, []);

  const renderButtons = () => (
    <button
      className="btn btn-primary w-100 text-bold"
      onClick={() => {
        history.push(`/onboarding/totp-verify`, { ...state });
      }}
      type="button">
      {translate('generic_next')}
    </button>
  );

  return (
    <SecurityTOTPBodyLayout
      title={translate('totp_secret_save_title')}
      renderButtons={renderButtons}
      withBack
      onPrevClick={history.goBack}>
      <div className="alert alert-warning my-4" role="alert">
        <i className="icon icon-info-icon" />
        <span className="content">{translate('totp_secret_save_alert_label')}</span>
      </div>

      <Input
        groupClassName={`mb-0 mt-4 ${isIOS ? 'ios' : ''}`}
        type="text"
        className={`form-control-input bg-light pe-5 ${isIOS ? 'ios' : ''}`}
        placeholder={translate('totp_secret_save_key_placeholder')}
        label={translate('totp_secret_save_key_placeholder')}
        name="key"
        defaultValue={state?.secret}
        required
        readOnly
        withFloatingLabel
        inputGroupChildren={
          <>
            <div
              className="icon position-absolute"
              role="button"
              onClick={() => copyToClipboard(state?.secret)}
              onKeyDown={null}
              tabIndex={-1}
              aria-label="Copy to Clipboard">
              <Icon icon={ICONS.CLIPBOARD} color={MAIN_ICON_COLORS.SHADOW} />
            </div>
          </>
        }
      />
    </SecurityTOTPBodyLayout>
  );
};

export default SecuritySaveTOTPKey;
